import React, { FC, ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { useReportViewEvent, useResponsive } from '../../hooks'
import { ReduxState } from '../../store/reducers'
import { StepTemplate } from '../styled/stepTemplate/StepTemplate'
import { Footer } from '../Footer/Footer'
import { Button } from '../styled/CosmaButton/CosmaButton'
import { IntegrationType } from '../../@types/config'
import NumberedListContent from './NumberedListContent'
import './Consultation.scss'

interface ConsultationProps {
  goToNextStep: (val?: boolean) => unknown
  goToPreviousStep: () => unknown
  displayBack: boolean
  headline?: ReactNode
  textString?: string
  icon?: ReactNode
  numberedListContent?: ReactNode
  className?: string
}

const tinyColor = require('tinycolor2')

export const Consultation: FC<ConsultationProps> = (props) => {
  useReportViewEvent({ pageTitle: 'consultation' })
  const { config } = useSelector((state: ReduxState) => state)
  const { theme, integrationType } = config
  const { isMobile } = useResponsive()

  const subIconContent = (
    <div className='sub-icon-content align-center padding-bottom-l'>
      <p className={'font-bold'}>Svenja Gruber</p>
      <p>Deine persönliche Immobilienspezialistin</p>
    </div>
  )

  return (
    <>
      <StepTemplate
        icon={props.icon}
        subIconContent={subIconContent}
        headline={props.headline}
        footer={isMobile && <Footer />}
        headlineClassname={'consultation-leads-headline font-bold'}
        displayNext={false}
        hideIconOnMobile={false}
        goToPreviousStep={props.goToPreviousStep}
        displayBack={props.displayBack}
        className='consultation-step'
        isExtendedBuyerLead={true}
      >
        <NumberedListContent className={props.className} />
        <div className='grid-item one-whole margin-top-xxl padding-horizontal-l align-center'>
          <Button
            data-testid='consultation-cta'
            onClick={() => props.goToNextStep(true)}
            appearance='primary'
            className={`palm-one-whole status-btn`}
            primary={theme.primary}
            secondary={theme.secondary}
            textColor={
              integrationType === IntegrationType.EXTERNAL && tinyColor(theme?.primary).isDark()
                ? '#FFFFFF'
                : theme.text
            }
            secondaryLight={theme.secondaryLight}
          >
            {props.textString}
          </Button>
        </div>
        <div
          className='grid-item one-whole margin-top-m padding-horizontal-l align-center'
          data-testid='consultation-link'
        >
          <a
            href='#/'
            onClick={() => props.goToNextStep(false)}
            style={{ color: integrationType === IntegrationType.IMMOVERKAUF24 ? '#2780ba' : '#2267e8' }}
          >
            Mit der Bewertung fortfahren
          </a>
        </div>
      </StepTemplate>
      {!isMobile && <Footer />}
    </>
  )
}

export default Consultation
